export default function NoBorderButton({onClick, children}){
    return (
        <>
            <span onClick={onClick} className="text-black font-medium cursor-pointer">{children}</span>
        </>
    );
}